<template>
    <div class="Info">
        <div class="InfoTop">
            <div class="InfoTopBtn BgBlue" @click="Toggle">发布建议</div>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <!-- <el-table-column prop="group" label="反馈类型"></el-table-column> -->
            <el-table-column prop="content" label="留言内容"></el-table-column>
            <el-table-column prop="roall_content" label="回复内容"></el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showDetail(scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="PageDis">
            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
        </div>
        <el-dialog :visible.sync="suggestBlon" :width="Wid" :show-close="false" @close="suggestBlon=false">
            <div class="StepJiBen">
                <!-- <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">反馈类型</span></div>
                    <div class="StepJiBenItemVal">
                        <el-select class="WidMax" size="medium" placeholder="请选择" v-model="SetData.group">
                            <el-option label="伦理投诉" value="伦理投诉"></el-option>
                            <el-option label="意见反馈" value="意见反馈"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">留言内容</span></div>
                    <div class="StepJiBenItemVal">
                        <el-input type="textarea" :rows="6" placeholder="请输入" v-model="SetData.content"></el-input>
                    </div>
                </div>
            </div>
            <div class="OrderBtns">
                <div class="OrderBtn" @click="suggestBlon=false">取消</div>
                <div class="OrderBtn BgBlue" @click="SetInfo">提交</div>
            </div>
        </el-dialog>

        <!-- 详情对话框 -->
        <el-dialog title="留言详情" :visible.sync="detailDialog" :width="Wid" custom-class="detail-dialog">
            <div class="detail-content">
                <div class="detail-item">
                    <div class="detail-label">留言内容：</div>
                    <div class="detail-value">{{detailData.content}}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">回复内容：</div>
                    <div class="detail-value">{{detailData.roall_content}}</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Wid:"60%",
                tableData:[],
                total:0,
                page:1,
                SizePage:10,
                SetData:{
                    group:"",
                    content:"",
                },
                suggestBlon:false,
                detailDialog: false,
                detailData: {},
            }
        },
        mounted() {
            this.Wid = this.$Global._isMobile()?"90%":"60%";
            this.GetData();
        },
        methods: {
            GetData(){
                this.$get("api/user/messageList",{
                    page:this.page,
                    limit:this.SizePage,
                }).then(res => {
                     if(res.data.code == 1){
                         this.total = res.data.data.total;
                         this.tableData = res.data.data.data;
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })
            },
            Toggle(){
                this.suggestBlon = !this.suggestBlon;
            },
            SetInfo(){
                // if(this.SetData.group == ""){this.$message.error("请选择反馈类型");return;}
                if(this.SetData.content ==""){this.$message.error("请输入留言内容");return;}
                var Quy = JSON.parse(JSON.stringify(this.SetData))
                this.$post("api/user/messageAdd",Quy).then(res => {
                     if(res.data.code == 1){
                         this.page = 1;
                         this.SetData = {};
                         this.GetData();
                         this.Toggle();
                         this.$message.success(res.data.msg)
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
            SizeChange(val) {
                this.SizePage = val;
                this.GetData();
            },
            PageChange(val) {
                this.page = val;
                this.GetData();
            },
            showDetail(row) {
                this.detailData = row;
                this.detailDialog = true;
            },
        },
    }
</script>
<style scoped>
    .InfoTit{
        padding: 20px 0;
        color: #000;
        font-size: 24px;
    }
    .InfoTop{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
    }
    .InfoTopBtn{
        padding: 3px 20px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
        color: #0385EB;
        border-radius: 5px;
        border: 2px solid #0385EB;
        margin-right: 20px;
        cursor: pointer;
    }
    .InfoTopBtn.BgBlue{
        background: #0385EB;
        color: #fff;
    }
   .StepJiBen{
       width: 100%;
   }
   .StepJiBenItem{
       display: flex;
       align-items: center;
       margin-bottom: 40px;
   }
   .StepJiBenItemTit{
       width: 135px;
       text-align: right;
       margin-right: 20px;
   }
   .StepJiBenItemTit .Tit{
       font-weight: 400;
       font-size: 16px;
       color: #999;
   }
   .StepJiBenItemVal{
       flex: 1;
   }
   .StepJiBenItemVal .WidMax{
       width: 100%;
   }
   .OrderBtns{
       display: flex;
       align-items: center;
       justify-content: center;
       margin: 20px 0;
   }
   .OrderBtn{
        padding: 5px 40px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        color: #0385EB;
        border-radius: 30px;
        border: 1px solid #0385EB;
        margin-right: 20px;
        cursor: pointer;
   }
   .OrderBtn.BgBlue{
       background: #0385EB;
       color: #fff;
   }
   .PageDis{
       display: flex;
       align-items: center;
       justify-content: center;
       padding: 20px;
   }
   @media only screen and (max-width: 550px) {
       .InfoTit{
           display: none;
       }
      .StepJiBen{
          width: 100%;
          margin: 0;
      }
      .StepJiBenItemTit{
          width: 80px;
      }
      .StepJiBenItemTit .Tit{
          font-size: 16px;
      }
   }
   .detail-dialog {
       border-radius: 8px;
       overflow: hidden;
   }
   .detail-dialog /deep/ .el-dialog__header {
       background: #f5f7fa;
       padding: 15px 20px;
       margin-right: 0;
       border-bottom: 1px solid #e4e7ed;
   }
   .detail-dialog /deep/ .el-dialog__title {
       font-size: 16px;
       font-weight: 600;
       color: #303133;
   }
   .detail-dialog /deep/ .el-dialog__headerbtn {
       top: 18px;
   }
   .detail-content {
       padding: 24px;
   }
   .detail-item {
       background: #f8f9fb;
       border-radius: 6px;
       padding: 16px;
       margin-bottom: 16px;
       transition: all 0.3s ease;
   }
   .detail-item:hover {
       box-shadow: 0 2px 12px 0 rgba(0,0,0,.05);
       transform: translateY(-2px);
   }
   .detail-label {
       font-weight: 500;
       margin-bottom: 12px;
       color: #606266;
       font-size: 14px;
   }
   .detail-value {
       color: #303133;
       line-height: 1.6;
       font-size: 14px;
       word-break: break-all;
       white-space: pre-wrap;
   }
   @media only screen and (max-width: 550px) {
       .detail-content {
           padding: 16px;
       }
       .detail-item {
           padding: 12px;
           margin-bottom: 12px;
       }
       .detail-label {
           margin-bottom: 8px;
       }
   }
</style>